var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs"),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "aside" },
          [
            _c(
              "BjDivider",
              {
                scopedSlots: _vm._u([
                  {
                    key: "right",
                    fn: function () {
                      return [
                        _c("el-button", { on: { click: _vm.onReset } }, [
                          _vm._v(_vm._s(_vm.$t("resetText"))),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [_vm._v(" 操作 ")]
            ),
            _c(
              "el-form",
              { attrs: { "label-suffix": "：" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "单据号" } },
                  [
                    _c("BjInput", {
                      ref: "codeDom",
                      attrs: { placeholder: "出库通知单号/物流单号" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onChangeCode.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.form.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "code", $$v)
                        },
                        expression: "form.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("goodsPage.skuCode") } },
                  [
                    _c("BjInput", {
                      ref: "skuCodeDom",
                      attrs: { placeholder: "系统SKU编码" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onChangeSkuCode.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.form.skuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "skuCode", $$v)
                        },
                        expression: "form.skuCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-descriptions",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      column: 1,
                      border: "",
                      "label-style": { width: "120px" },
                      "content-style": { "max-width": "208px" },
                      "content-class-name": "ellipsis",
                    },
                  },
                  [
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "店铺名称" } },
                      [_vm._v(" " + _vm._s(_vm.data.shopName) + " ")]
                    ),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(" 出库通知单号 "),
                        ]),
                        _vm._v(" " + _vm._s(_vm.data.code) + " "),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(" 客户订单号 "),
                        ]),
                        _vm._v(" " + _vm._s(_vm.data.platformOrderCode) + " "),
                      ],
                      2
                    ),
                    _vm.data.logisticCompany
                      ? _c(
                          "el-descriptions-item",
                          [
                            _c("template", { slot: "label" }, [
                              _vm._v(
                                " " + _vm._s(_vm.data.logisticBusiness) + " "
                              ),
                            ]),
                            _vm._v(" " + _vm._s(_vm.data.logisticsNo) + " "),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(" 收件信息 "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.data.receiverNameMask) +
                            " " +
                            _vm._s(_vm.data.receiverPhoneMask) +
                            " "
                        ),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(" 收件地址 "),
                        ]),
                        _vm._v(" " + _vm._s(_vm.data.addressMask) + " "),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(" 买家备注 "),
                        ]),
                        _vm._v(" " + _vm._s(_vm.data.buyMsg) + " "),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(" 客服备注 "),
                        ]),
                        _vm._v(" " + _vm._s(_vm.data.orderMsg) + " "),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    staticClass: "text-center",
                    staticStyle: { margin: "20px 0" },
                  },
                  [
                    _c(
                      "el-col",
                      { staticClass: "checkText", attrs: { span: 12 } },
                      [
                        _c("p", [_vm._v("应验")]),
                        _c("span", [_vm._v(_vm._s(_vm.data.qty || 0))]),
                      ]
                    ),
                    _c(
                      "el-col",
                      { staticClass: "checkText", attrs: { span: 12 } },
                      [
                        _c("p", [_vm._v("已验")]),
                        _c("span", { staticClass: "success" }, [
                          _vm._v(_vm._s(_vm.checkedNum)),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "printFlag", label: "扫描后打印面单" } },
                  [
                    _c("el-switch", {
                      model: {
                        value: _vm.printFlag,
                        callback: function ($$v) {
                          _vm.printFlag = $$v
                        },
                        expression: "printFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "print", label: "打印机" } },
                  [
                    _vm.webSocketOptions.length
                      ? _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.webSocketOptions,
                            clearable: false,
                          },
                          model: {
                            value: _vm.print,
                            callback: function ($$v) {
                              _vm.print = $$v
                            },
                            expression: "print",
                          },
                        })
                      : [
                          _c("span", [_vm._v("未获取打印机")]),
                          _c(
                            "el-button",
                            {
                              staticClass: "ml15",
                              attrs: { type: "text" },
                              on: { click: _vm.onConnet },
                            },
                            [_vm._v("连接打印机")]
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "main" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.data.odoDetailList } },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "spuCode",
                    label: "商品编码",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "spuName",
                    label: "商品名称",
                    align: "center",
                    width: "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "skuCode", label: "SKU编码", align: "center" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "skuName",
                    label: "SKU名称",
                    align: "center",
                    width: "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "plannedQty",
                    label: "需求数/订单数量",
                    align: "center",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "checkQty",
                    label: "检验数/出库数量",
                    align: "center",
                    width: "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(" " + _vm._s(row.checkQty || 0) + " ")]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("Alert", { ref: "alert" }),
      _c("audio", {
        ref: "alertAudioEl",
        attrs: { autoplay: "", src: _vm.audioUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }